import React from 'react';
import Pylon2Board from './Pylon2Board';

const Pylon2LeftLeg = () => {
  return <Pylon2Board legType="left" />;
};

export default Pylon2LeftLeg;
